import { createSlice } from "@reduxjs/toolkit";
import Api from "../../api/Api";
import {IObjectKeys} from "../../constants/interfaces";

type State = {
	data: IObjectKeys,
	isLoading: boolean,
	error: Object | null
}

// Slice
const slice = createSlice({
	name: "metric",
	initialState: {
		data: {},
		isLoading: false,
		error: null,
	},
	reducers: {
		fetchSingleMetricStart: (state: State) => {
			state.isLoading = true;
		},
		fetchSingleMetricSuccess: (state: State, action) => {
			state.isLoading = false;
			const { data, cellId } = action.payload;
			state.data[cellId] = (data.total || data.total === 0) ? data.total : data;
		},
		fetchSingleMetricFailed: (state: State, action) => {
			state.isLoading = false;
			state.error = action.payload;
		}
	},
});

export default slice.reducer;

// Actions
const { 
	fetchSingleMetricStart, 
	fetchSingleMetricSuccess, 
	fetchSingleMetricFailed 
} = slice.actions;

export const getSingleMetric = (cellId: number, metric: string, brands: string, interval: any, sections: string, tags: string, conversions: string, eventFields: string, isPaid: string, videoFilter: string, pageType: string, referrers: string, referrerTypes: string, includeChannels: string, excludeChannels: string, pubdateInterval: string, userNeeds:string) => async (dispatch: Function) => {
	try {
		dispatch(fetchSingleMetricStart());
		const api = new Api();
		const result = await api.getSingleMetric(metric, brands, interval, sections, tags, conversions, eventFields, isPaid, videoFilter, pageType, referrers, referrerTypes, includeChannels, excludeChannels, pubdateInterval, userNeeds);
		const payload = {
			data: result,
			cellId
		}
		if (result !== "No internet connection") {
			dispatch(fetchSingleMetricSuccess(payload));
		}
	} catch (err: any) {
		dispatch(fetchSingleMetricFailed(err));
	}
};
